<script lang="ts" generics="TValues">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import { cx } from '$lib/utils/cx.js';
    import type { ChangeEvent } from '$lib/utils/types.js';
    import { cubicInOut } from 'svelte/easing';
    import { crossfade } from 'svelte/transition';
    import type { SearchHeaderFormData_TypeEnum } from '$gql/graphql';

    export let form: Form<TValues, string>;
    export let field: Field<TValues, SearchHeaderFormData_TypeEnum>;

    let choices = [
        { value: 'company' as const, label: 'Sociétés' },
        { value: 'pro' as const, label: 'Professionnels' },
        { value: 'newsfeed' as const, label: 'Réseaux' },
        { value: 'job' as const, label: 'Emplois' },
    ];

    function onCheckboxInput(event: ChangeEvent<HTMLInputElement>) {
        const value = event.currentTarget.value;

        if (
            value === 'company' ||
            value === 'pro' ||
            value === 'newsfeed' ||
            value === 'job'
        ) {
            form.dispatch(form.actions().changeValue(value, field));
        }
    }

    function onBlur() {
        form.dispatch(form.actions().blur(field));
    }

    function onFocus() {
        form.dispatch(form.actions().focus(field));
    }

    const [send, receive] = crossfade({
        duration: 250,
        easing: cubicInOut,
    });

    $: v = form.stores().fieldValue(field);
    $: id = form.getFieldId(field);
    $: choice = choices.find((choice) => choice.value === $v);
</script>

<div class={cx('flex gap-[32px] items-center justify-center')}>
    {#each choices as c (c.value)}
        <label class={cx('cursor-pointer group relative')} for="{id}.key-{c.value}">
            <input
                class="absolute w-[1px] h-[1px] opacity-0"
                type="radio"
                id="{id}.key-{c.value}"
                name={id}
                value={c.value}
                checked={c.value === choice?.value}
                on:input={onCheckboxInput}
                on:focus={onFocus}
                on:blur={onBlur}
            />

            <div
                class={cx(
                    'text-white text-16 leading-[20px] font-bold',
                    c.value === $v ? 'opacity-100' : 'opacity-80 group-hover:opacity-100',
                )}
            >
                {c.label}
            </div>

            {#if c.value === $v}
                <div
                    in:send={{ key: 'trigger' }}
                    out:receive={{ key: 'trigger' }}
                    class="absolute w-full h-[2px] mt-[1px] bg-brand-yellow"
                />
            {/if}
        </label>
    {/each}
</div>
